import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJsmChatopsSlackAppSelectorRoute } from '@jira/router-routes__products-jsm-chatops-slack-app-selector-routes/src/productsJsmChatopsSlackAppSelectorRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { productsJsmChatopsSlackAppSelectorEntryPoint } from '@jira/spa-apps__admin-pages-products-jsm-chatops-slack-app-selector/src/productsJsmChatopsSlackAppSelectorEntryPoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const entryPoint = createPageEntryPoint({
	main: productsJsmChatopsSlackAppSelectorEntryPoint,
});

export const productsJsmChatopsSlackAppSelectorRouteEntry: Route = createEntry(
	productsJsmChatopsSlackAppSelectorRoute,
	() => ({
		group: 'global-settings',

		entryPoint: () => {
			if (!fg('support_chatops_on_ic')) {
				return undefined;
			}
			return entryPoint;
		},
		layout: opsSettingsLayout,

		navigation: {
			menuId: MenuIdSettings,
			sidebarId: SidebarIdOperationsGeneralConfiguration,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

		forPaint: [LazySidebarContent, LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
